import React, { useEffect, useState } from "react";
import { loadStyles } from "../../utils/cssLoader";
import BasketballRounds from "./BasketballRounds";
import BasketballTeamScoreBox from "./BasketballTeamScoreBox";
import NoDataFound from "../common/NoDataFound";

const BasketballScoring = ({
  data,
  loadCSS = true,
  dataClient = false,
  title,
  sport = "basketball",
}) => {
  const [clientData, setClientData] = useState(null);

  useEffect(() => {
    if (!dataClient) return;
    const container = document?.querySelector(".microservice-cont");
    const raw = container?.getAttribute("data-listingdata");
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw)?.data?.data;
      setClientData(parsed || null);
    } catch (err) {
      console.error("Failed to parse data-listingdata:", err);
    }
  }, [dataClient]);

  useEffect(() => {
    if (loadCSS) {
      loadStyles("basketballlineup");
      loadStyles("basketballscoring");
    }
  }, [loadCSS]);

  const scoringData = dataClient ? clientData : data;

  if (!scoringData) {
    return <NoDataFound />;
  }

  const extractScores = (summary, quarter) => {
    const score = summary?.[`q${quarter}`]?.split("-") || [];
    return {
      hScore: score[0] || "0",
      aScore: score[1] || "0",
    };
  };

  const scores = [];
  for (let i = 1; i <= 4; i++) {
    scores.push(extractScores(scoringData?.summary, i));
  }

  const hasRoundsData = scoringData?.summary?.competitors;
  const hasLeagueTableData = scoringData?.league_table?.length > 0;

  if (!hasRoundsData && !hasLeagueTableData) {
    return <NoDataFound text="No scoring data available" />;
  }

  return (
    <div className="basketball_scoring_container">
      {title && <h1>{title}</h1>}

      {hasRoundsData && (
        <BasketballRounds
          score={scores}
          data={scoringData?.summary?.competitors}
          sport={sport}
        />
      )}

      {hasLeagueTableData && (
        <BasketballTeamScoreBox
          data={scoringData?.league_table}
          sport={sport}
        />
      )}
    </div>
  );
};

export default BasketballScoring;
